/**
 * Einstieg für Vite (npm run build). Jedes Modul kümmert sich um ein
 * Bedienelement und prüft selbst, ob es auf der Seite vorkommt - ohne
 * JavaScript bleibt jede Seite vollständig benutzbar.
 */
import jobProgress from './modules/job-progress.js';
import providerCheck from './modules/provider-check.js';
import tableTruncate from './modules/table-truncate.js';
import repeatRows from './modules/repeat-rows.js';
import costPreview from './modules/cost-preview.js';
import charts from './modules/charts.js';
import answerMatrix from './modules/answer-matrix.js';
import tabs from './modules/tabs.js';
import autoSubmit from './modules/auto-submit.js';
import requiredUnless from './modules/required-unless.js';
import checkAll from './modules/check-all.js';
import dependsOn from './modules/depends-on.js';
import promptCategories from './modules/prompt-categories.js';
import confirmSubmit from './modules/confirm.js';
import themeSwitch from './modules/theme-switch.js';
import dialogs from './modules/dialog.js';
import sortTables from './modules/sort-table.js';
import sortable from './modules/sortable.js';
import topbar from './modules/topbar.js';
import rememberOpen from './modules/remember-open.js';

[
  confirmSubmit,
  jobProgress,
  providerCheck,
  tableTruncate,
  repeatRows,
  costPreview,
  charts,
  answerMatrix,
  tabs,
  autoSubmit,
  requiredUnless,
  checkAll,
  dependsOn,
  promptCategories,
  themeSwitch,
  dialogs,
  sortTables,
  sortable,
  topbar,
  rememberOpen,
].forEach((init) => init());
